import { domReady } from 'utilities/dom';

const ZERO_STRING = '00000000-0000-0000-0000-000000000000';

// method for on submit button clicked
function submitJobSearch (e) {

	e.preventDefault();
	let selectedRegion = document.getElementById('regions').value;
	let selectedJobType = document.getElementById('jobTypes').value;

	if (selectedRegion === ZERO_STRING) {

		selectedRegion = '';

	}

	if (selectedJobType === ZERO_STRING) {

		selectedJobType = '';

	}

	window.location.href = `/careers/SearchCareers.aspx?regionid=${selectedRegion}&jobtypeid=${selectedJobType}`;

}

domReady(() => {

	const submitJobSearchBtn = document.getElementById('submitJobSearch');

	if (submitJobSearchBtn) {

		submitJobSearchBtn.addEventListener('click', submitJobSearch);

	}

	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

	}

});
